export default __webpack_public_path__ + "static/media/517.5eff0006.png";